import api from '../utils/api';
export const fetchSubcounties = async () => {
  const response = await api.get('/subcounties');
  return response.data;
};